export const authConst = {
    SET_AUTH_USER: "SET_AUTH_USER"
}